<script>
import {useRouter} from "vue-router";

export default {
  name: "Registration",
  setup() {
    const registrationFees = [
      {
        rate: 'Regular',
        earlyBird: '4,000 Baht',
        registration: '4,500 Baht'
      },
      {
        rate: 'Student',
        earlyBird: '2,000 Baht',
        registration: '2,500 Baht'
      },
      {
        rate: 'Overseas Participants**',
        earlyBird: '500 USD',
        registration: '550 USD'
      }
    ];

    return {
      registrationFees
    }
  }
}
</script>

<template>
  <div class="conference-fees">
    <div>
        <!-- <h2>step 1: Please register for an account. (<router-link to="/register">register</router-link>)</h2> -->
        <h2>If you wish to report, please submit an abstract. (<router-link to="/abstract">submit</router-link>)</h2>
        <!-- <h2>step 3: You can pay your registration fee by scanning the QR code (China mainland users) or make the payment offline (China mainland users and People from other regions).</h2> -->
      <!-- <br>
      <el-table :data="registrationFees" style="width: 100%" border stripe>
        <el-table-column prop="rate" label="Rate" width="200">
        </el-table-column>
        <el-table-column prop="earlyBird" label="Early bird" width="200">
        </el-table-column>
        <el-table-column prop="registration" label="Registration">
        </el-table-column>
      </el-table> -->
        <h2>Dear Prof. please check this link. 
            <a href="http://www.ictp2026thailand.com">www.ictp2026thailand.com</a>
        </h2>
        <br />
    </div>
    
    <div>
        
        <img src="../../assets/images/registration.jpg" />
    </div>

    <!-- <div>
        <p class="note">
            * Registration free including 1 day trip and domestic transportation
        </p>
        <p class="note">
            * You can pay your registration fee either by UnionPay, Alipay, or WeChat Pay.
        </p>
        <p class="note">
            * Please note when making a payment: <b>Name;  Phone number;  Invoice Company;  Tax number;  Email address</b>
        </p>
      <img src="../../assets/images/qrcode.png" alt="Photo 1" class="photo" />
    </div> -->
  </div>
</template>

<style scoped>
.conference-fees {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  margin: 0 auto;
  padding: 20px;
  max-width: 66%;
}

h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

h2 {
  font-size: 1.5em;
  margin-top: 1.5em;
}

h3 {
  font-size: 1.2em;
  margin-top: 1em;
}

.fee-category {
  margin-bottom: 1em;
}

p {
  margin: 0.5em 0;
}

a {
  color: #1e90ff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.note {
   margin-top: 10px; font-size: 14px; color: #666; 
}
</style>
